import { FormattedMessage } from 'react-intl'

export default function StickyHeader({ locationTitle, selectedDates }) {
  return (
    <div className='pt-sticky-top fixed' sticky-top='sticky-top' clickable='true' trigger='#la-main-filters' >
      <div className='search-wrapper'>
        <div className='back-section'>
          <h5 className='title'>{ locationTitle }</h5>
          <div className='details'>
            <span><FormattedMessage id='liveaboards' defaultMessage='Liveaboards' />,</span>
            <span>{ selectedDates }</span>
            <a className='action-edit pointer'>
              <FormattedMessage id='edit' defaultMessage='Edit' />
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}
